<template>
    <div id="content">
        <div class="container-fluid page-title">
            <div class="container">
                <h1>
                    Seja um Parceiro
                </h1>
            </div>
        </div>
        <div class="container page-content">
            <div class="row pb-5">
                <div class="col-lg-6 col-md-12 text-justify">
                    <h3 style="font-weight: 300; color: #c70000">Nada na sua empresa será como antes.</h3>
                    <b>
                        Assista ao vídeo e conheça o nosso modelo de negócios, que é focado na simplicidade e no acesso
                        facilitado a você, Empreendedor.
                    </b>
                    <div class="embed-responsive embed-responsive-16by9 mt-2 mb-2">
                        <iframe class="embed-responsive-item"
                                src="https://www.youtube.com/embed/mbsmQFoV11A" frameborder="0"
                                allowfullscreen></iframe>
                    </div>

                    <b>
                        Temos a melhor oportunidade de crescimento para o seu negócio,<br>
                        entre em contato que juntos faremos as suas vendas decolarem!
                    </b>
                </div>
                <div class="col-lg-6 col-md-12">
                    <form name="Parceiro" id="formParceiro" v-on:submit.prevent="sendMail">

                        <div class="form-row">

                            <div class="form-group col-md-6">
                                <label for="Parceiro_razao_social" class="required">Razão Social:</label>
                                <input type="text" id="Parceiro_razao_social" name="razao_social"
                                       v-model="formParceiro.razao_social"
                                       required="required"
                                       class="form-control">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="Parceiro_nome_fantasia" class="required">Nome Fantasia:</label>
                                <input type="text" id="Parceiro_nome_fantasia" name="nome_fantasia"
                                       v-model="formParceiro.nome_fantasia"
                                       required="required"
                                       class="form-control">
                            </div>

                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="Parceiro_cnpj" class="required">CNPJ:</label>
                                <input type="text" id="Parceiro_cnpj" name="cnpj" required="required"
                                       v-model="formParceiro.cnpj"
                                       class="form-control">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="Parceiro_ie" class="required">IE:</label>
                                <input type="text" id="Parceiro_ie" name="ie" required="required"
                                       v-model="formParceiro.ie"
                                       class="form-control">
                            </div>

                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="Parceiro_nome_contato" class="required">Nome para Contato:</label>
                                <input type="text" id="Parceiro_nome_contato" name="nome_contato"
                                       v-model="formParceiro.nome_contato"
                                       required="required"
                                       class="form-control">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="Parceiro_email" class="required">Email:</label>
                                <input type="email" id="Parceiro_email" name="email" required="required"
                                       v-model="formParceiro.email"
                                       class="form-control">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="Parceiro_tel_fixo" class="required">Telefone Fixo:</label>
                                <input type="text" id="Parceiro_tel_fixo" name="tel_fixo" required="required"
                                       v-model="formParceiro.tel_fixo"
                                       class="form-control">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="Parceiro_celular" class="required">Celular:</label>
                                <input type="text" id="Parceiro_celular" name="celular" required="required"
                                       v-model="formParceiro.celular"
                                       class="form-control">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <label for="Parceiro_motivo_parceria"
                                       class="required">Porque deseja ser um parceiro da Simonetti?</label>
                                <textarea id="Parceiro_motivo_parceria" name="motivo_parceria"
                                          v-model="formParceiro.motivo_parceria"
                                          required="required"
                                          class="form-control" rows="5"></textarea>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label class="required">Estado:</label>
                                <select name="estado" required="required" id="estados" class="form-control"
                                        v-model="formParceiro.estado">
                                    <option value="">Escolha um Estado</option>
                                    <option value="BH">Bahia</option>
                                    <option value="ES">Espirito Santo</option>
                                    <option value="MG">Minas Gerais</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="Parceiro_cidade" class="required">Cidade:</label>
                                <input type="text" id="Parceiro_cidade" name="cidade" required="required"
                                       v-model="formParceiro.cidade"
                                       class="form-control">
                            </div>
                        </div>

                        <div class="form-group col-md-12 text-center">
                            <div class="alert alert-info" v-if="enviandoEmail">
                                Aguarde...
                            </div>
                            <div class="alert alert-success" v-if="emailEnviado">
                                Aguarde, nossa equipe entrará em contato com você! Faremos um bom negócio!
                            </div>
                            <div class="alert alert-danger" v-if="emailNaoEnviado">
                                Houve um problema ao enviar seu email, tente novamente.
                            </div>
                            <button type="submit" id="Parceiro_enviar" class="btn btn-lg btn-danger">
                                Quero ser um parceiro
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data: () => ({
            formParceiro: {
                razao_social: null,
                nome_fantasia: null,
                cnpj: null,
                ie: null,
                nome_contato: null,
                email: null,
                tel_fixo: null,
                celuar: null,
                cidade: null,
                estado: null,
                motivo_parceria: null,
                errors: [],
            },
            emailEnviado: false,
            emailNaoEnviado: false,
            enviandoEmail: false,
        }),
        methods: {
            sendMail() {
                this.enviandoEmail = true;
                axios.post('/seja-um-parceiro', this.formParceiro)
                    .then(response => {
                        if (response.data.status) {
                            this.emailEnviado = true;
                            this.enviandoEmail = false;
                            document.getElementById("formParceiro").reset();
                        } else {
                            this.emailNaoEnviado = true;
                            this.enviandoEmail = false;
                        }
                    })
                    .catch(e => {
                        this.emailNaoEnviado = true;
                        this.enviandoEmail = false;
                        this.errors.push(e)
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SejaParceiro.vue?0d4054ef